import { Button } from "@ui/Button";
import { Tooltip, TooltipTrigger } from "@ui/Tooltip";
import { Show } from "solid-js";
import { useSpeechToText } from "./useSpeechToText";

type Props = {
	disabled: boolean;
	onBeginSession: () => void;
	onEndSession: () => void;
	onTranscript: (text: string, isFinal: boolean) => void;
};

export const ListenToUserButton = (props: Props) => {
	const speech = useSpeechToText({
		disabled: () => props.disabled,
		onBeginSession: props.onBeginSession,
		onEndSession: props.onEndSession,
		onTranscript: props.onTranscript,
	});

	return (
		<Show when={speech.isSupported()}>
			<TooltipTrigger>
				<Button
					type="button"
					variant="text"
					theme="monochrome"
					shape="circle"
					size="large"
					symbol={speech.isListening() ? "mic_off" : "mic"}
					disabled={props.disabled}
					class="gvtui-question-box__voice-button"
					classList={{
						"gvtui-question-box__voice-button": true,
						"gvtui-question-box__voice-button--listening": speech.isListening(),
					}}
					aria-label={
						speech.isListening() ? "Stop voice input" : "Start voice input"
					}
					aria-pressed={speech.isListening()}
					onClick={speech.toggle}
				/>
				<Tooltip>
					<p>
						{speech.isListening() ? "Stop listening" : "Speak your question"}
					</p>
				</Tooltip>
			</TooltipTrigger>
		</Show>
	);
};
